import { ZoneModel } from 'models/zone.model';
import { AnyAction, Reducer } from 'redux';

import { ALL_ZONES } from './zone.types';

export interface ZoneState {
  allZones: string[];
  zones: ZoneModel[];
}

const initialSettings: ZoneState = {
  allZones: [],
  zones: []
};

const reducer: Reducer<ZoneState> = (
  state: ZoneState = initialSettings,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case ALL_ZONES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
